module.exports = __webpack_public_path__ + "static/media/image-covid19.d7265326.png";